module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Paradis perdu")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Par Shira Anthony")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il est dangereux de chercher des secrets enfouis.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lorsqu’une énorme société menace de reprendre son entreprise, Adam Preston, prodige de la programmation, échappe au stress en prenant des vacances plus que méritées en République Dominicaine. Il y rencontre Jonah James, un instructeur de plongée sous-marine, séduisant, intelligent et perspicace. Ce qui commence comme une aventure de vacances devient bientôt beaucoup plus sérieux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mais Jonah a un secret : dix ans auparavant, il s’est réveillé sur une plage de l’île sans savoir comment il y est arrivé… ni même qui il est. Leur paradis n’est peut-être pas aussi parfait qu’il le paraît. Lorsque les souvenirs de Jonah recommencent à affluer comme des vagues sur le sable, Adam s’agrippera-t-il au radeau de sauvetage ou les deux hommes trouveront-ils un havre de sécurité pour se sortir de la tempête ?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bddcee48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 60
// module chunks = 0